import React from 'react'
import { QuestionPageList } from 'components'

const QuestionSearch = () => <QuestionPageList />

export default QuestionSearch
